import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)

  return (
    data?.map((item: any, index: any) => {
      return {
        approvalStatus: item?.approvalStatus,
        approvalType: item?.approvalType,
        className: item?.className,
        id: item?.id,
        key: item?.key,
        type: item?.type,
        username: item?.username,
        data: {
          type: 'package',
          id: item?.object?.id,
          group: item?.object?.group,
          category: item?.object?.category,
          packageName: item?.object?.packageName,
        },
      }
    }) ?? []
  )
}

const getPackagePendingApprovals = (elevated: boolean, tokens: any, fileType) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingPendingApprovals),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      elevated,
      fileType
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getPackagePendingApprovals }
